import { CustomDatePicker } from "components/DatePicker";
import { defaultRangePresets } from "constants/RangePickerConstants";
import { endOfDay, isAfter, isBefore, startOfDay, subDays } from "date-fns";
import { useCallback, useContext } from "react";

import { FindingsContext } from "../contexts/FindingsContext";

const MAX_LOOKBACK_DAYS = 30;

export const FindingsDatePicker: React.FC = () => {
  const { range, setRange } = useContext(FindingsContext);
  const disabledRange = useCallback(
    (date?: Date) =>
      !!date &&
      (isBefore(date, startOfDay(subDays(new Date(), MAX_LOOKBACK_DAYS))) ||
        isAfter(date, endOfDay(new Date()))),
    []
  );

  const onUpdateRange = useCallback(
    (range: [Date | null, Date | null] | null) => {
      if (!range) setRange([undefined, undefined]);
      else {
        const [start, end] = range;
        setRange([start ?? undefined, end ?? undefined]);
      }
    },
    [setRange]
  );

  return (
    <CustomDatePicker.RangePicker
      allowEmpty={[true, true]}
      disabledDate={disabledRange}
      presets={defaultRangePresets({ includeTime: false })}
      value={range}
      onChange={onUpdateRange}
    />
  );
};
